import { isEmpty, trim } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

const tablePropTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
}

const tableDefaultProps = {
  children: null
}

const TableHeadCell = ({ children }) => <th>{children}</th>

TableHeadCell.propTypes = tablePropTypes
TableHeadCell.defaultProps = tableDefaultProps

const TableDataCell = ({ children }) => <td>{children}</td>

TableDataCell.propTypes = tablePropTypes
TableDataCell.defaultProps = tableDefaultProps

const TableRow = ({ children }) => (
  <tr>
    {children.map(child => {
      if (isEmpty(trim(child))) {
        return null
      }

      if (child.type === 'th') {
        return <TableHeadCell key={child.key} {...child.props} />
      }

      if (child.type === 'td') {
        return <TableDataCell key={child.key} {...child.props} />
      }

      return null
    })}
  </tr>
)

TableRow.propTypes = tablePropTypes
TableRow.defaultProps = tableDefaultProps

const TableHead = ({ children }) => (
  <thead>
    {children.map(child => {
      if (isEmpty(trim(child))) {
        return null
      }

      return <TableRow key={child.key} {...child.props} />
    })}
  </thead>
)

TableHead.propTypes = tablePropTypes
TableHead.defaultProps = tableDefaultProps

const TableBody = ({ children }) => (
  <tbody>
    {children.map(child => {
      if (isEmpty(trim(child))) {
        return null
      }

      return <TableRow key={child.key} {...child.props} />
    })}
  </tbody>
)

TableBody.propTypes = tablePropTypes
TableBody.defaultProps = tableDefaultProps

const Table = ({ children }) => {
  const tableContent = children.map(child => {
    if (isEmpty(trim(child))) {
      return null
    }

    if (child.type === 'thead') {
      return <TableHead key={child.key} {...child.props} />
    }

    if (child.type === 'tbody') {
      return <TableBody key={child.key} {...child.props} />
    }

    return null
  })

  return <table>{tableContent}</table>
}

Table.propTypes = tablePropTypes
Table.defaultProps = tableDefaultProps

export default Table
